import { ApiFormattedResponse } from "@models/api_formatted_response"
import { GraphQLBody } from "@models/graphql_body"
import { LoginFormData } from "@pages/public/login/sub_components/login_form"
import { mutate } from "@utils/graphql"
import {
  CustomerPaymentCard,
  CustomerPaymentCardOutput,
  EmailResponse,
  MutationUpdateCustomerPersonArgs,
  RemoveCustomerPaymentCardInput,
  UpdateCustomerPersonInput,
  UserTokenData,
  UserTokenResponse
} from "__generated__/graphql"
import adminSignIn from "__generated__/queries/mutations/adminSignIn"
import removeCustomerPaymentCard from "__generated__/queries/mutations/removeCustomerPaymentCard"
import resendVerificationEmail from "__generated__/queries/mutations/resendVerificationEmail"
import updateCustomerPerson from "__generated__/queries/mutations/updateCustomerPerson"

export async function login(
  data: LoginFormData
): Promise<ApiFormattedResponse<UserTokenData>> {
  const response = await mutate<{
    adminSignIn?: UserTokenResponse
  }>({
    mutation: adminSignIn,
    variables: {
      data: {
        email: data.email,
        password: data.password
      }
    }
  })

  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    ...response,
    data: response.data?.adminSignIn?.data as UserTokenData
  }
}

export async function resendVerificationMail(
  email: string
): Promise<ApiFormattedResponse<unknown>> {
  const response = await mutate<{
    resendVerificationEmail?: EmailResponse
  }>({
    mutation: resendVerificationEmail,
    variables: {
      email
    }
  })

  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }

  return {
    isSuccess: true
  }
}

export async function resetPassword(data: {
  _id: string
  customerId: string
  password: string
}): Promise<ApiFormattedResponse<UpdateCustomerPersonInput>> {
  const response = await mutate<{
    updateCustomerPerson?: MutationUpdateCustomerPersonArgs
  }>({
    mutation: updateCustomerPerson,
    variables: {
      data: {
        _id: data._id,
        customerId: data.customerId,
        password: data.password
      }
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: response?.data?.updateCustomerPerson?.data
  }
}

export async function deleteCustomerPaymentCard(
  data: RemoveCustomerPaymentCardInput
): Promise<ApiFormattedResponse<CustomerPaymentCard>> {
  const response = await mutate<
    {
      removeCustomerPaymentCard?: CustomerPaymentCardOutput
    },
    GraphQLBody<RemoveCustomerPaymentCardInput>
  >({
    mutation: removeCustomerPaymentCard,
    variables: {
      input: data
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: response?.data?.removeCustomerPaymentCard?.data as CustomerPaymentCard
  }
}
